import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

import { Loading } from 'components/Loading';

const StyledLoading = styled(Loading)`
  margin: 0 auto;
`;

const StyledThreeColumnsChild = styled(Flexer.Child)`
  flex: 1;
  width: 33%;
  margin-right: 16px;
  :last-child {
    margin-right: 1rem;
  }
`;

export { StyledLoading, StyledThreeColumnsChild };
